export default "__VITE_ASSET__BtN6qXbG__"